// src/lib/supabase.js
import { createClient } from "@supabase/supabase-js";

// The squiggle on process is a deno linting error that can probably be fixed in the settings.json file
const supabaseKey = process.env.VUE_APP_SUPABASE_KEY;
const supabaseUrl = process.env.VUE_APP_SUPABASE_URL;

export const supabase = createClient(supabaseUrl, supabaseKey);
